(function(){
    'use strict';

    angular
    .module('app')
    .controller('PaginasfieldController', PaginasfieldController)
 
    PaginasfieldController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function PaginasfieldController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.datos = {};
        vm.fieldName = ""
        vm.datos.page_id = "";
		vm.datos.url_enlace = "";

		vm.htmlDecode = function(input){
          var e = document.createElement('div');
          e.innerHTML = input;
          return e.childNodes[0].nodeValue;
        }
		
		vm.update = function(){
			var json = angular.toJson(vm.datos);
			$timeout(function(){
				$('#'+vm.fieldName+'-jsonpag').val(json).trigger("change");
			});
		}

        vm.initVars = function(fieldName,value){
        	if(value!=""){
               value = vm.htmlDecode(value);
        	   value = JSON.stringify(value);
               value = value.replace(/\\n/g, "");
               value = value.replace(/\\r/g, "");
               value = value.replace(/\\t/g, "");
               value = value.replace(/([^>"]*)"(?=[^<]*>)/g, '$1\\\\"');
        	   value = JSON.parse(value);
        	   vm.datos = JSON.parse(value);
            }
        	vm.fieldName = fieldName;
			//console.log(vm.datos);
            vm.update();
        }
    } 

})();